export const json_config ={
    headers:{
        'Content-Type':'application/json'
    }
}

export const multipart_config = {
    headers:{
        'Content-Type':'multipart/form-data'
    }
}
